/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import _ from 'lodash';
import emojione from 'emojione';

const EMOJI_IMG = /<img\b[^>]*\bclass="emojione"[^>]*>/g;

// A post's text as preview HTML: no markup except links and emojione images, as the legacy feed showed it.
// cleanUp strips every tag, uMarkdown's emoji images included, so they're swapped for their Unicode alt text
// first. ulinky then links mentions, hashtags and URLs; statuses also get the mentions filter, as before.
export function toPreviewHtml(html: string, $filter: any, mentions?: any): string {
  let text = $filter('ulinky')($filter('cleanUp')(html.replace(EMOJI_IMG, (img) => /\balt="([^"]*)"/.exec(img)?.[1] || '')));
  if (mentions) text = $filter('mentions')(text, mentions);
  return emojione.toImage(text);
}

// Plain text as HTML with emojione images, for text that never went through uMarkdown.
export function toEmojiHtml(text: string): string {
  return emojione.toImage(_.escape(text));
}

// Plain text for accessible names: shortcodes become Unicode emoji, which screen readers announce by name.
export function toEmojiText(text: string): string {
  return emojione.shortnameToUnicode(text ?? '');
}
